import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { AppState } from 'src';

import {
  ContractPaymentConfirmationComponent,
  ContractPaymentConfirmationComponentProperties
} from './contract-payment-confirmation.component';
import { sendPaymentReceiptEmail, setEmailAddresses } from '../contract-payment-confirmation.actions';
import { getContractDetails } from '../../../../../contract.actions';
import { toggleModal } from '../../../../../../common/components/common.actions';
import {
  HostedCheckoutCardSave,
  HostedCheckoutCardSaveContainerProperties
} from 'src/payment/_components/gateway/hosted-checkout-card-save-container';

export interface ContractPaymentConfirmationContainerProperties {
  readonly contractId: number;
  readonly creditCardLastFour?: string;
  readonly refundAmount?: number;
  readonly saveCallback?: Function;
  readonly buttonRef?: (button: HTMLButtonElement) => void;
  readonly paymentDate?: Date;
  readonly isTransactionCompletionScreen?: boolean;
  readonly transactionId?: number;
}

// This is used to translate the state of the page to the props on the component
function mapStateToProps(
  state: AppState,
  ownProps: ContractPaymentConfirmationContainerProperties
): Partial<ContractPaymentConfirmationComponentProperties> {
  return {
    contract: state.contract.contractDetailsVM,
    contractId: ownProps.contractId,
    creditCardLastFour: ownProps.creditCardLastFour,
    emailAddresses: state.contract.payment.confirmation.emailAddresses,
    refundAmount: ownProps.refundAmount,
    paymentDate: ownProps.paymentDate,
    isTransactionCompletionScreen: ownProps.isTransactionCompletionScreen || false
  };
}

// This should create proxy wrappers for actions used by the component
function mapDispatchToProps(
  dispatch: Dispatch<AppState>,
  ownProps: ContractPaymentConfirmationContainerProperties
): Partial<ContractPaymentConfirmationComponentProperties> {
  return {
    buttonRef: ownProps.buttonRef,
    getContract: (contractId: number) => dispatch(getContractDetails(contractId)),
    setEmailAddresses: (emailAddresses: string[]) => dispatch(setEmailAddresses(emailAddresses)),
    submit: (contractId: number, emailAddresses: string[], paymentDate: Date, creditCardLastFour?: string) =>
      dispatch(sendPaymentReceiptEmail(contractId, emailAddresses, paymentDate, creditCardLastFour)).then(() => {
        if (ownProps.saveCallback) {
          ownProps.saveCallback();
        }
      }),
    openCardSaveModal: () => {
      dispatch(
        toggleModal<HostedCheckoutCardSaveContainerProperties>({
          title: 'Save Credit Card',
          component: HostedCheckoutCardSave,
          childProps: {
            transactionId: ownProps.transactionId,
            buttonRef: null,
            isInModal: true
          }
        })
      );
    }
  };
}

// Connect function "wires" both of the map functions and returns a wrapper container for the component
export const ContractPaymentConfirmation = connect(
  mapStateToProps,
  mapDispatchToProps
)(ContractPaymentConfirmationComponent);



// WEBPACK FOOTER //
// ./src/contract/_components/contract-payment/_components/confirmation/_components/contract-payment-confirmation.container.ts